import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { useSessaoAtual } from '../../../services/app/providers';
import { useCallback } from 'react';
import { RotasMock } from 'data/mocks/rotas-mock';
import { EnumTipoCobrancaRevenda } from 'model/enums/enum-tipo-cobranca-revenda';
import { EnumTipoPessoas } from 'model/enums/enum-tipo-pessoas';

export const ValidateRoute: React.FC<RouteProps> = ({
  children,
  ...otherProps
}) => {
  const { tipoUsuario, usuario } = useSessaoAtual();
  const { pathname } = useLocation()

  const retRoute = useCallback(() => {
    const modulo = RotasMock.find(item => pathname.includes(item.rota));
    if (modulo?.permissoes.includes(tipoUsuario())) return children
    const redirectTo = RotasMock.find(item => {
      if (
        item.rota === pathname
        && (usuario?.TipoCobrancaRevenda !== EnumTipoCobrancaRevenda.ClienteFinal)
        && tipoUsuario() === EnumTipoPessoas.FuncionarioFinanceiroSemCusto
      )
        return false

      return item.permissoes.includes(tipoUsuario())
    })
    return <Redirect to={redirectTo?.rota || '/dashboard'} />

  }, [children, pathname, tipoUsuario, usuario?.TipoCobrancaRevenda]);

  return <Route {...otherProps}>{retRoute()}</Route>;
};
